export default "<div>\n  <formly-transclude></formly-transclude>\n\n</div>\n";